import React from 'react';
import { Link } from 'react-router-dom';
import { useScrollToSection } from '../hooks/useScrollToSection';
import './HomepageNav.css';

const HomepageNav = () => {
  const scrollToSection = useScrollToSection();

  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    scrollToSection(sectionId);
  };

  return (
    <nav className="homepage-nav">
      <div className="homepage-nav__container">
        <Link to="/" className="homepage-nav__logo" aria-label="Go to homepage">
          <img
            src="/img/nintschew_logo_2.png"
            alt="Nintschew & Partner Logo"
            className="homepage-nav__logo-image"
          />
        </Link>

        <div className="homepage-nav__menu">
          <a href="#about" className="homepage-nav__link" onClick={(e) => handleNavClick(e, '#about')}>Über uns</a>
          <a href="#team" className="homepage-nav__link" onClick={(e) => handleNavClick(e, '#team')}>Team</a>
          <a href="#services" className="homepage-nav__link" onClick={(e) => handleNavClick(e, '#services')}>Leistungen</a>
          <Link to="/news" className="homepage-nav__link">News</Link>
          <a href="#contact-form" className="homepage-nav__cta" role="button" onClick={(e) => handleNavClick(e, '#contact-form')}>
            Anfrage senden
          </a>
        </div>
      </div>
    </nav>
  );
};

export default HomepageNav;
